import {computed, Injector, signal, Signal} from '@angular/core';
import {BehaviorSubject, Observable, of, Subject} from 'rxjs';
import {DexComputedLpService} from '../../components/dex/dex-streaming/computed/dex-computed-lp.service';
import {DexComputedTrancheService} from '../../components/dex/dex-streaming/computed/dex-computed-tranche.service';
import {ComputedTranche} from '../../components/dex/dex-streaming/types/computed/computed-tranche';
import {
    WidgetImplementation,
    WidgetImplementationEvent,
    WidgetImplementationEventFlags
} from '../../components/layout/widget/widget-implementation';
import {
    getWidgetSettingsWithUpdatesStream,
    hasSettingUpdateField,
    pipeSettingsCorrections,
    setWidgetSettings,
    updateWidgetSettings
} from '../components/common-widget.implementation';
import {DexLpWidgetSettings} from './settings/dex-lp-widget-settings';
import {DexLpWidgetSettingsService} from './settings/dex-lp-widget-settings.service';

export class DexLpWidgetImplementation implements WidgetImplementation {

    public settings: DexLpWidgetSettings;

    public settingsService: DexLpWidgetSettingsService = this.injector.get(DexLpWidgetSettingsService);

    public ready$ = new BehaviorSubject<boolean>(false);

    public event$ = new Subject<WidgetImplementationEvent>();

    public settingsWithUpdates$: Observable<Partial<DexLpWidgetSettings>> =
               getWidgetSettingsWithUpdatesStream(this);

    public readonly $lp = computed(() => this.dexComputedLpService.$list()[0]);
    public readonly $traches: Signal<ComputedTranche[]>;
    public readonly $expandedSymbol: Signal<string | null>;

    private readonly $expandedSymbolWritable = signal<string | null>(null);

    private readonly dexComputedLpService = this.injector.get(DexComputedLpService);
    private readonly dexComputedTrancheService = this.injector.get(DexComputedTrancheService);

    constructor(
        private injector: Injector
    ) {
        this.$traches = this.dexComputedTrancheService.$list;
        this.$expandedSymbol = this.$expandedSymbolWritable.asReadonly();
    }

    public setSettings(
        settings?: DexLpWidgetSettings,
        flags?: WidgetImplementationEventFlags
    ): Observable<DexLpWidgetSettings> {
        return setWidgetSettings(this, settings, flags);
    }

    public updateSettings(
        updates?: Partial<DexLpWidgetSettings>,
        flags?: WidgetImplementationEventFlags
    ): Observable<Partial<DexLpWidgetSettings>> {
        return updateWidgetSettings(this, updates, flags);
    }

    public resolveSettings(
        settings: Partial<DexLpWidgetSettings>
    ): Observable<Partial<DexLpWidgetSettings>> {
        return pipeSettingsCorrections<DexLpWidgetSettings>([
            s => this.resolveSettingsExpandedSymbol(s)
        ])(settings, this);
    }

    private resolveSettingsExpandedSymbol(
        settingsUpdate: Partial<DexLpWidgetSettings>
    ): Observable<Partial<DexLpWidgetSettings>> {
        if (hasSettingUpdateField(settingsUpdate, 'expandedSymbol')) {
            this.$expandedSymbolWritable.set(settingsUpdate.expandedSymbol);
        }

        return of(undefined);
    }

}
